import { cashSessionApi } from "../../api";

const CashSessionService = {

    /**
     * 🔎 Obtener estado de caja de una terminal POS
     * GET /api/cash/sessions/status/{registerId}
     */
    getSessionStatus: async (registerId: number) => {
        const response = await cashSessionApi.fetchCustom(`/status/${registerId}`);
        return response.data;
    },

    /**
     * 🔓 Abrir sesión de caja
     * POST /api/cash/sessions/open
     */
    openSession: async (data: any) => {
        const response = await cashSessionApi.addCustom("/open", data);
        return response.data;
    },

    /**
     * 📍 Obtener sesión activa
     * GET /api/cash/sessions/active/{registerId}
     */
    getActiveSession: async () => {
        const response = await cashSessionApi.fetchCustom(`/active`);
        return response.data;
    },

};

export default CashSessionService;